import React from "react";
import { clsx } from "clsx";

export interface AvatarProps extends React.HTMLAttributes<HTMLSpanElement> {
    name?: string;
    src?: string;
    size?: "sm" | "md" | "lg";
}

const sizeMap = { sm: "h-8 w-8 text-xs", md: "h-10 w-10 text-sm", lg: "h-12 w-12 text-base" };

function initials(name?: string) {
    if (!name) return "?";
    return name
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((p) => p[0]?.toUpperCase())
        .join("");
}

export const Avatar: React.FC<AvatarProps> = ({ name, src, size = "md", className, ...props }) => (
    <span
        className={clsx(
            "inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary/15 font-semibold text-primary",
            sizeMap[size],
            className,
        )}
        title={name}
        {...props}
    >
        {src ? <img src={src} alt={name ?? ""} className="h-full w-full object-cover" /> : initials(name)}
    </span>
);
